<template>
	<div class="toast" v-show="visible">
		<span>{{ message }}</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			message: ''
		};
	},

	mounted() {},
	methods: {
		showToast: function() {
			this.visible = true;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../style/common';

.toast {
	position: fixed;
	top: 50%;
	transform: translateY(-50%);
	font-size: px2rem(30rem);
	color: #fff;
	left: 0;
	width: 100%;
	line-height: px2rem(42rem);
	z-index: 9999;
	text-align: center;
	span {
		padding: px2rem(18rem) px2rem(30rem);
		border-radius: 5px;
		background: rgba(0, 0, 0, 0.7);
		display: inline-block;
		max-width: 4.2rem;
		text-align: left;
		word-break: break-all;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/toast.vue